import React from 'react';
import { productPresentation } from '../../lib/productPresentation';
import { productArtwork } from '../../lib/productArtwork';
import { compoundFingerprint, formatStrengthLabel } from '../../lib/compoundFingerprint';
import BatchtrueMark from './BatchtrueMark';
import CompoundTraceCanvas from './CompoundTraceCanvas';
import './ProductSpecimen.css';

export default function ProductSpecimen({ product, className = '' }) {
  const { kind, strength, count, packLabel } = productPresentation(product);
  const artwork = productArtwork(product);
  const name = String(product.name || 'Compound').trim();
  const strengthLabel = formatStrengthLabel(strength);
  const formatLabel = kind === 'vials' && count === 10 ? '10 VIAL KIT' : packLabel.toUpperCase();
  const fingerprint = compoundFingerprint({ name, strength: strengthLabel });

  return (
    <figure className={`product-specimen ${className}`} data-testid="product-specimen"
      data-sku={String(product.sku || '')} data-format={kind}
      data-fingerprint={fingerprint.signature} data-master="unified" data-artwork={artwork.key}>
      <div className="product-specimen__locked-card" aria-hidden="true">
        <img className="product-specimen__locked-master" src="/images/products/batchtrue-card-conformity-20261004.webp" alt="" />
        <div className="product-specimen__brand">
          <BatchtrueMark className="product-specimen__mark" />
          <span>Batchtrue <small>WHOLESALE</small></span>
        </div>
        <div className="product-specimen__headline">
          <strong className="product-specimen__name">{name}</strong>
        </div>
        <strong className="product-specimen__dose">{strengthLabel}</strong>
        <CompoundTraceCanvas points={fingerprint.points} signature={fingerprint.signature} />
        {artwork.assetPath && <img className={`product-specimen__product product-specimen__product--${artwork.key}`} src={artwork.assetPath} alt="" />}
        <div className="product-specimen__spec-row">
          <strong>{formatLabel}</strong>
          <strong>Research use only</strong>
        </div>
        <div className="product-specimen__footer-row">
          <span>Illustrative trace. Not test data.</span>
          <span>COA: check current product record.</span>
        </div>
      </div>
      <figcaption className="sr-only">
        {name}, {strengthLabel}, {formatLabel}. Research use only. Trace is a visual system, not test data. Check the current product record for COA information.
      </figcaption>
    </figure>
  );
}
